import React from 'react';
import { Link } from 'react-router-dom';

type BuildProps = {
  response: any;
  isApprovalRequired: boolean;
  isTrialToTrialConversion: boolean;
  hasOptedForUpgradeTrial?: boolean;
};

enum OrderTransitionType {
  SCHEDULED = 'SCHEDULED',
  IMMEDIATE = 'IMMEDIATE',
}

export const buildMessage = ({
  response,
  isApprovalRequired,
  isTrialToTrialConversion,
  hasOptedForUpgradeTrial,
}: BuildProps) => {
  switch (true) {
    case response?.transitionTime === OrderTransitionType.IMMEDIATE && hasOptedForUpgradeTrial:
      return {
        header: 'Subscription changes submitted',
        message: (
          <div>
            <p>
              The customer is now on a no-cost trial of Premium plan. You can view the changes in the&nbsp;
              <strong>order history</strong>&nbsp;tab.
            </p>
            <Link to={`#order-history`}>View order history</Link>
          </div>
        ),
      };
    case response?.transitionTime === OrderTransitionType.IMMEDIATE && isTrialToTrialConversion:
      return {
        header: 'Subscription changes submitted',
        message: (
          <div>
            <p>You can view the changes in the order history tab.</p>
            <Link to={`#order-history`}>View order history</Link>
          </div>
        ),
      };
    case response?.transitionTime === OrderTransitionType.IMMEDIATE && !isApprovalRequired:
      return {
        header: 'Subscription changes submitted',
        message: (
          <div>
            <p>
              A new invoice is being generated for applicable subscription changes and will be available in 24 hours.
              You can view the changes in the &nbsp;<strong>order history</strong>&nbsp; tab.
            </p>
            <Link to={`#order-history`}>View order history</Link>
          </div>
        ),
      };
    case response?.transitionTime === OrderTransitionType.IMMEDIATE && isApprovalRequired:
      return {
        header: 'Subscription changes pending',
        message: (
          <div>
            <p>
              The discount approval request has been created. You can view it in the &nbsp;
              <strong>approval requests</strong>&nbsp; tab. If approved, a new invoice for applicable subscription
              changes will then be available in 24 hours, and you’ll be able to view the changes in the &nbsp;
              <strong>order history</strong> &nbsp;tab.
            </p>
            <Link to={`#approvals`}>View approval request</Link>
          </div>
        ),
      };
    case response?.transitionTime === OrderTransitionType.SCHEDULED && !isApprovalRequired:
      return {
        header: 'Subscription changes pending',
        message: (
          <>
            <p>This change will take place on the next bill date.</p>
            <Link to={'#scheduled-changes'}>View scheduled changes</Link>
          </>
        ),
      };
    case response?.transitionTime === OrderTransitionType.SCHEDULED && isApprovalRequired:
      return {
        header: 'Subscription changes pending',
        message: (
          <div>
            <p>
              The discount approval request has been created. You can view it in the approval requests tab. If approved,
              subscription changes will take place on the next bill date.
            </p>
            <Link to={`#approvals`}>View approval request</Link>
          </div>
        ),
      };
    default:
      return {
        header: 'Subscription changes submitted',
        message: (
          <div>
            <p>
              A new invoice is being generated for applicable subscription changes and will be available in 24 hours.
              You can view the changes in the &nbsp;<strong>order history</strong>&nbsp; tab.
            </p>
            <Link to={`#order-history`}>View order history</Link>
          </div>
        ),
      };
  }
};
